import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    tabbarShow: true
  },
  mutations: {
    changeBar(state, isshow) {
      state.tabbarShow = isshow
    }
  },
  actions: {
    changeBar(context, isshow) {
      context.commit('changeBar', isshow)
    }
  },
  modules: {}
})
